// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Q7HS","field":"styles_field__2bc0M","fieldCol":"styles_fieldCol__2PpXr","diffCol":"styles_diffCol__3bIFx","diff":"styles_diff__2QrJh"};